'use strict';

module.exports = require('./lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/react-dom/server.js
// module id = 408
// module chunks = 0